import { render, staticRenderFns } from "./allotTask.vue?vue&type=template&id=40e2fcf7&scoped=true"
import script from "./allotTask.vue?vue&type=script&lang=js"
export * from "./allotTask.vue?vue&type=script&lang=js"
import style0 from "./allotTask.vue?vue&type=style&index=0&id=40e2fcf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2fcf7",
  null
  
)

export default component.exports